function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M28 0C12.4727 0 0 12.4727 0 28C0 43.5273 12.4727 56 28 56C43.5273 56 56 43.5273 56 28C56 12.4727 43.5273 0 28 0ZM21.3822 42.2545L11.9635 32.8364C10.9453 31.8182 10.9453 30.2909 11.9635 29.2727C12.9817 28.2545 14.5093 28.2545 15.5275 29.2727L21.3822 35.1274L39.2004 17.3092C40.2186 16.291 41.7456 16.291 42.7638 17.3092C43.7819 18.3274 43.7819 19.8544 42.7638 20.8726L21.3822 42.2545Z"
});

var SvgCheckmarkLarge = function SvgCheckmarkLarge(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCheckmarkLarge, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/checkmarkLarge.0d3ad38a.svg";
export { ForwardRef as ReactComponent };